import { FC } from "react";
import { Flex } from "@chakra-ui/react";
import { Steps } from "./Steps";

export const StepsConditional: FC = () => {
  return (
    <Flex display={{ base: "initial", lg: "none" }} mb={10} mt={7}>
      <Steps />
    </Flex>
  );
};
